<template>
  <div class="row">
    <div class="col-sm-6 col-md-4">
      <div class="row">
        <div class="mt-3">
          <input
            type="file"
            :disabled="!permissions.editStudentsPersonalinformation"
            ref="profile_image"
            style="display: none"
            @input="showSelectedImage"
            accept="image/*"
          />
          <div v-if="student.Photo" class="position-relative" @mouseover="hovering = true" @mouseleave="hovering = false">
            <img
              :src="imageUrl"
              @dblclick="replaceImage"
              class="img-responsive"
              style="cursor: pointer; max-width: 250px; max-height: 250px; border: 1px solid black"
            />
            <div
              class="icon-overlay position-absolute w-100 d-flex justify-content-center"
              style="left: 0; right: 0; opacity: 0; transition: opacity 0.3s"
              :style="{ opacity: hovering ? 1 : 0 }"
            >
              <button class="btn btn-sm btn-primary mx-2" @click="replaceImage">
                <i class="fas fa-edit"></i>
              </button>
              <button class="btn btn-danger btn-sm mx-2" @click="confirmDelete">
                <i class="fas fa-times-circle"></i>
              </button>
            </div>
          </div>

          <div v-else class="position-relative">
            <img
              :src="imageUrl"
              @click="$refs.profile_image.click()"
              class="img-responsive"
              style="cursor: pointer; max-width: 250px; max-height: 250px; border: 1px solid black"
            />
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="form-group col-12">
          <label>{{ $t("form.student.programStart") }}</label>
          <date-picker
            class="date-picker"
           
            :lang="lang"
            v-model="student.ProgramStart"
            :disabled="!permissions.editStudentsPersonalinformation"
            valueType="format"
            :format="dateFormat"
            :popup-style="{ top: '100%', left: 0 }"
            :append-to-body="false"
          >
          </date-picker>
        </div>
        <div class="form-group col-12">
          <label for="StatusID:">{{ $t("form.student.status") }}</label>

          <v-select
            label="StatusName"
            :disabled="!permissions.editStudentsPersonalinformation"
            @input="onChangeStatus()"
            :options="statusList"
            v-model="changeStatus"
            :reduce="(statusList) => statusList"
          >
          </v-select>
        </div>
        <div class="form-group col-12" v-if="statusCreateMode">
          <label for="StudentStatusComment:">{{
            $t("form.student.studentStatusComment")
          }}</label>
          <input
            type="text"
            name="StudentStatusComment"
            v-model="status.StatusComment"
            class="form-control"
            :disabled="!permissions.editStudentsPersonalinformation"
          />
        </div>
        <div class="form-group col-12">
          <label for="StudentStatusDate">{{
            $t("form.student.studentStatusDate")
          }}</label>
         
          <date-picker
            class="date-picker"
            :lang="lang"
            :disabled="!permissions.editStudentsPersonalinformation"
            @input="onChangeStatusDate"
            v-model="StatusDate"
            valueType="format"
            :format="dateFormat"
            :popup-style="{ top: '100%', left: 0 }"
            :append-to-body="false"
          >
          </date-picker>
        </div>
        <div class="form-group col-6">
          <label for="StudentdPermitExpiryDate">{{
            $t("form.student.permitExpiryDate")
          }}</label>
       
          <date-picker
            class="date-picker"
            :lang="lang"
            :disabled="!permissions.editStudentsPersonalinformation"
            :class="{ 'is-invalid': isInvalidDate2 }"
            v-model="student.PermitExpiry"
            valueType="format"
            :format="dateFormat"
            :popup-style="{ top: '100%', left: 0 }"
            :append-to-body="false"
          >
          </date-picker>
        </div>
        
        <div class="form-group col-6">
          <label for="StudentPassportExpiryDate">{{
            $t("form.student.passportExpiryDate")
          }}</label>

          <date-picker
            class="date-picker"
            :class="{ 'is-invalid': isInvalidDate }"
            id="passportDate"
            :lang="lang"
            :disabled="!permissions.editStudentsPersonalinformation"
            v-model="student.PassportExpiry"
            valueType="format"
            :format="dateFormat"
            :popup-style="{ top: '100%', left: 0 }"
            :append-to-body="false"
          >
          </date-picker>
        </div>
        <div class="col-12" v-if="statusCreateMode">
          <button
            type="button"
            @click="addStatus()"
            class="btn btn-primary btn-block"
            :disabled="
              !status.StatusID ||
              readonly ||
              !permissions.editStudentsPersonalinformation
            "
          >
            {{ $t("button.updateStatus") }}
          </button>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-12">
          <h5 class="font-weight-bold">
            {{ $t("form.student.statusHistory") }}
          </h5>
          <table class="table table-bordered">
            <tr>
              <th>{{ $t("form.student.status") }}</th>
              <th>{{ $t("form.student.statusDate") }}</th>
              <th>{{ $t("form.student.statusNote") }}</th>
              <th
                class="text-center"
                v-if="permissions.deleteStudentsStatushistory"
              >
                {{ $t("form.student.action") }}
              </th>
            </tr>
            <tbody>
              <tr v-for="(status, index) in studentStatus" v-bind:key="index">
                <td>{{ status.StudentStatusName }}</td>
                <td>{{ status.StudentStatusDate | formatDate(dateFormat) }}</td>
                <td>{{ status.StudentStatusComment }}</td>
                <td
                  class="text-center"
                  v-if="permissions.deleteStudentsStatushistory"
                >
                  <button
                    class="btn btn-danger btn btn-sm"
                    v-on:click="deleteStatusEntry(index)"
                  >
                    <span class="fa fa-trash"></span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-12">
          <label>{{ $t("form.student.notes") }}</label>
          <textarea
            name="Note"
            v-model="student.Notes"
            rows="3"
            :disabled="!permissions.editStudentsPersonalinformation"
            class="form-control"
          ></textarea>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <label>{{ $t("form.student.linkedRecords") }}</label>

          <ul class="list-group m-0">
            <div class="input-group">
                <input id="StudentNameField" type="text" class="form-control"
                    placeholder="Search Student by Name"
                    v-model="studentName"
                    v-on:keyup="searchStudent()">
                <div class="input-group-append">
                    <span class="input-group-text remove_btn" v-on:click="clear()">
                        <i class="fa fa-times"></i></span>
                </div>

            </div>

            <li class="list-group-item" v-for="(student,index) in options" :key='index'>
                <a @click="addLink(student)">
                  {{student.StudentNumber}} - {{student.FirstName}} {{student.LastName}}
                </a>
            </li>
          </ul>

          <ul class="list-group mt-2" v-if="linkedStudents.length">
            <li
              v-for="student in linkedStudents"
              :key="student.id"
              class="list-group-item d-flex justify-content-between align-items-center"
            >
              <a @click="editStudent(student.student_number)">
                {{ student.full_name }} ({{ student.student_number }})
              </a>
              <button @click="removeLink(student.id)" class="btn btn-sm btn-danger">Unlink</button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col-sm-6 col-md-5">
      <!-- // image partner -->
      <div class="form-group">
        <label for="StudentNumber">
          {{ $t("form.student.studentNumber") }}
          <span class="req" style="color: red">*</span>
        </label>
        <div class="controls">
          <input
            id="StudentNumber"
            disabled
            name="StudentNumber"
            v-model="student.StudentNumber"
            type="text"
            class="form-control"
            data-role="text"
            required="required"
            data-parsley-errors-container="#errId2"
          />
          <span id="errId2" class="error"></span>
        </div>
      </div>

      <div
        class="form-group"
        v-if="student.PartnerID == 1"
      >
        <label for="MatriculationNumField">
          {{ $t("form.student.matriculationNum") }}
        </label>
        <input
          type="text"
          id="MatriculationNumField"
          class="form-control"
          v-model.trim="$v.student.MatriculationNum.$model"
          :class="{
            'is-invalid': $v.student.MatriculationNum.$error,
          }"
        />
        <div
          class="invalid-feedback"
          v-if="!$v.student.MatriculationNum.maxLength"
        >
          {{
            $t("form.validation.maxDigits", {
              num: $v.student.MatriculationNum.$params.maxLength.max,
            })
          }}
        </div>
      </div>

      <div class="form-group">
        <label for="Title">{{ $t("form.student.title") }}</label>
        <div class="controls">
          <v-select
            :options="titles"
            :key="student.Title"
            v-model="student.Title"
            :disabled="!permissions.editStudentsPersonalinformation"
            :reduce="(titles) => titles"
          >
          </v-select>
        </div>
      </div>

      <div class="form-group">
        <label for="FirstNameField">
          {{ $t("form.student.firstName") }}
          <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          id="FirstNameField"
          class="form-control"
          :disabled="!permissions.editStudentsPersonalinformation"
          :class="{ 'is-invalid': $v.student.FirstName.$error }"
          v-model.trim="$v.student.FirstName.$model"
        />
        <div class="invalid-feedback" v-if="!$v.student.FirstName.required">
          {{ $t("form.validation.required") }}
        </div>
        <div class="invalid-feedback" v-if="!$v.student.FirstName.maxLength">
          {{
            $t("form.validation.maxLength", {
              num: $v.student.FirstName.$params.maxLength.max,
            })
          }}
        </div>
      </div>

      <div class="form-group">
        <label for="LastNameField">
          {{ $t("form.student.lastName") }}
          <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          id="LastNameField"
          class="form-control"
          :disabled="!permissions.editStudentsPersonalinformation"
          v-model.trim="$v.student.LastName.$model"
          :class="{ 'is-invalid': $v.student.LastName.$error }"
        />
        <div class="invalid-feedback" v-if="!$v.student.LastName.required">
          {{ $t("form.validation.required") }}
        </div>
        <div class="invalid-feedback" v-if="!$v.student.LastName.maxLength">
          {{
            $t("form.validation.maxLength", {
              num: $v.student.LastName.$params.maxLength.max,
            })
          }}
        </div>
      </div>
      <div class="form-group">
        <label for="TranscriptNameField">{{
          $t("form.student.transcriptName")
        }}</label>
        <input
          type="text"
          id="TranscriptNameField"
          class="form-control"
          :disabled="!permissions.editStudentsPersonalinformation"
          v-model.trim="student.TranscriptName"
        />
      </div>
      <div class="form-group">
        <label>{{ $t("form.student.birthDate") }}</label>
        <date-picker
          class="date-picker"
          :lang="lang"
          :disabled="!permissions.editStudentsPersonalinformation"
          v-model="student.BirthDate"
          valueType="format"
          :format="dateFormat"
          :popup-style="{ top: '100%', left: 0 }"
          :append-to-body="false"
          :placeholder="student.BirthDate"
        >
        </date-picker>
      </div>
      <div class="form-group">
        <label for="BirthPlaceField">
          {{ $t("form.student.birthPlace") }}
          <span class=""></span>
        </label>
        <input
          type="text"
          id="BirthPlaceField"
          :disabled="!permissions.editStudentsPersonalinformation"
          v-model.trim="$v.student.BirthPlace.$model"
          class="form-control"
          :class="{ 'is-invalid': $v.student.BirthPlace.$error }"
        />
       
        <div class="invalid-feedback" v-if="!$v.student.BirthPlace.maxLength">
          {{
            $t("form.validation.maxLength", {
              num: $v.student.BirthPlace.$params.maxLength.max,
            })
          }}
        </div>
      </div>
      <div class="form-group">
        <label>
          {{ $t("form.student.birthCountry") }}
        </label>
        <v-select
          label="printable_name"
          :options="countries"
          :disabled="!permissions.editStudentsPersonalinformation"
          v-model="student.BirthCountry"
          :reduce="(countries) => countries.printable_name"
          :key="student.BirthCountry"
        >
        </v-select>
      </div>
      <div class="form-group">
        <label>
          {{ $t("form.student.nationality") }}
        </label>
        <input
          type="text"
          v-model.trim="student.Nationality"
          :disabled="!permissions.editStudentsPersonalinformation"
          class="form-control"
        />
      </div>
      <div class="form-group">
        <label>{{ $t("form.student.streetAddress") }}</label>
        <input
          type="text"
          v-model.trim="student.StreetAddress"
          :disabled="!permissions.editStudentsPersonalinformation"
          class="form-control"
        />
      </div>

      <div class="form-group">
        <label>{{ $t("form.student.city") }}</label>
        <input
          type="text"
          v-model.trim="student.City"
          :disabled="!permissions.editStudentsPersonalinformation"
          class="form-control"
        />
      </div>

      <div class="form-group">
        <label>{{ $t("form.student.zip") }}</label>
        <input
          type="text"
          v-model.trim="student.Zip"
          class="form-control"
          :disabled="!permissions.editStudentsPersonalinformation"
        />
      </div>

      <div class="form-group">
        <label for="CountryField">{{ $t("form.student.country") }}</label>
        <v-select
          label="printable_name"
          :options="countries"
          :disabled="!permissions.editStudentsPersonalinformation"
          v-model.trim="student.Country"
          :reduce="(countries) => countries.printable_name"
          :key="student.Country"
        >
        </v-select>
      </div>

      <div class="form-group">
        <label for="PhoneField">{{ $t("form.student.phone") }}</label>
        <input
          type="text"
          id="PhoneField"
          v-model.trim="student.Phone"
          :disabled="!permissions.editStudentsPersonalinformation"
          class="form-control"
        />
      </div>

      <div class="form-group">
        <label for="MobileField">
          {{ $t("form.student.mobile") }}
        </label>
        <div class="d-flex align-items-center">
          <input
            type="text"
            id="MobileField"
            :disabled="!permissions.editStudentsPersonalinformation"
            v-model.trim="student.Mobile"
            class="form-control"
          />
          <a
            :href="`tel:${student.Mobile}`"
            class="btn btn-default text-nowrap"
            >{{ $t("button.call") }}</a
          >
        </div>
      </div>

      <div class="form-group">
        <label for="EmailField">
          {{ $t("form.student.email") }}
          <span class="text-danger">*</span>
        </label>
        <div class="d-flex align-items-center">
          <input
            type="email"
            id="EmailField"
            :disabled="!permissions.editStudentsPersonalinformation"
            v-model.trim="$v.student.Email.$model"
            class="form-control"
            :class="{ 'is-invalid': $v.student.Email.$error }"
          />
          <a
            :href="`mailto:${student.Email}`"
            class="btn btn-default text-nowrap"
            >{{ $t("button.email") }}</a
          >
        </div>
        <div class="invalid-feedback d-block" v-if="!$v.student.Email.required">
          {{ $t("form.validation.required") }}
        </div>
        <div class="invalid-feedback d-block" v-if="!$v.student.Email.email">
          {{ $t("form.validation.validEmail") }}
        </div>
      </div>

      <div class="form-group">
        <label for="Email2Field">{{ $t("form.student.email2") }}</label>
        <div class="d-flex">
          <input
            id="Email2Field"
            name="Email2"
            v-model="student.Email2"
            :disabled="!permissions.editStudentsPersonalinformation"
            type="text"
            class="form-control"
          />
          <a
            :href="`mailto:${student.Email2}`"
            class="btn btn-default text-nowrap"
            >{{ $t("button.email") }}</a
          >
        </div>
      </div>
      <div class="form-group">
        <label for="Email3Field">{{ $t("form.student.email3") }}</label>
        <div class="d-flex">
          <input
            id="Email3Field"
            name="Email3"
            v-model="student.Email3"
            :disabled="!permissions.editStudentsPersonalinformation"
            type="text"
            class="form-control"
          />
          <a
            :href="`mailto:${student.Email3}`"
            class="btn btn-default text-nowrap"
            >{{ $t("button.email") }}</a
          >
        </div>
      </div>
    </div>

    <div class="col-sm-4 col-md-3 mb-3 ml-auto">
      <div class="shadow mb-4 p-3">
        <h6>
          <u>
            <b>{{ $t("form.student.mailAddress") }}</b>
          </u>
        </h6>
        <div class="form-group">
          <label>
            <input
              type="radio"
              v-model="student.MailAddress"
              value="1"
              :disabled="!permissions.editStudentsPersonalinformation"
            />
            {{ $t("form.student.mailAddressOption1") }}
          </label>
        </div>
        <div class="form-group">
          <label>
            <input
              type="radio"
              v-model="student.MailAddress"
              value="2"
              :disabled="!permissions.editStudentsPersonalinformation"
            />
            {{ $t("form.student.mailAddressOption2") }}
          </label>
        </div>
      </div>

      <div class="shadow mb-4 p-3">
        <h6>
          <u>
            <b>{{ $t("form.student.exportAddress") }}</b>
          </u>
        </h6>
        <button
          class="btn btn-primary"
          @click="generate('pdf')"
          :disabled="!permissions.editStudentsPersonalinformation"
        >
          <i class="fas fa-file-pdf"></i>
        </button>

        <button
          class="btn btn-primary"
          @click="generate('word')"
          :disabled="!permissions.editStudentsPersonalinformation"
        >
          <i class="fas fa-file-word"></i>
        </button>

        <button
          class="btn btn-primary"
          @click="generate('text')"
          :disabled="!permissions.editStudentsPersonalinformation"
        >
          <i class="far fa-file-alt"></i>
        </button>
      </div>

      <div class="shadow mb-4 p-3">
        <u>
          <b>{{ $t("form.student.gradeNotify") }}</b>
        </u>
        <div class="form-group">
          <label>
            <input
              type="checkbox"
              v-model="student.SISEnabled"
              :disabled="!permissions.editStudentsPersonalinformation"
            />
            {{ $t("form.student.gradeNotifyOption1") }}
          </label>
          <br />
        </div>
        <div class="form-group">
          <label>
            <input
              type="checkbox"
              v-model="student.GradeNotification"
              :disabled="!permissions.editStudentsPersonalinformation"
            />
            {{ $t("form.student.gradeNotifyOption2") }}
          </label>
        </div>
        <div class="form-group">
          <label>
            <input
              type="checkbox"
              v-model="student.BirthdayNotification"
              :disabled="!permissions.editStudentsPersonalinformation"
            />
            {{ $t("form.student.gradeNotifyOption3") }}
          </label>
        </div>
      </div>

      <div class="shadow mb-4 p-3">
        <h6>
          <u>
            <b>{{ $t("form.student.legalization") }}</b>
          </u>
        </h6>
        <div class="form-group">
          <label>
            <input
              type="checkbox"
              v-model="student.LegalizationRequired"
              :disabled="!permissions.editStudentsPersonalinformation"
            />
            {{ $t("form.student.legalizationOption1") }}
          </label>
        </div>
      </div>

      <div class="shadow mb-4 p-3">
        <div class="form-group">
          <label for="Code">{{ $t("form.student.partnerCode") }}</label>
          <div class="controls" v-if="partners.length">
            <v-select
              label="PartnerCode"
              :options="partners"
              v-model="student.PartnerID"
              :key="student.PartnerID"
              @input="selectedPartner"
              :reduce="(partners) => partners.PartnerID"
              :disabled="
                partnersDisabled || !permissions.editStudentsPersonalinformation
              "
            >
            </v-select>
          </div>
        </div>
        <div class="form-group" style="padding-bottom: 10%">
          <label for="pCode">{{ $t("form.student.partnerCampus") }}</label>
          <div v-if="partnercampus.length">
            <v-select
              label="PartnerCampusLocation"
              :options="partnercampus"
              :disabled="!permissions.editStudentsPersonalinformation"
              :key="student.PartnerCampusID"
              v-model="student.PartnerCampusID"
              :reduce="(partnercampus) => partnercampus.PartnerCampusID"
              track-by="PartnerCampusID"
            >
            </v-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import vue2Dropzone from "vue2-dropzone";
import {
  required,
  maxLength,
  email
} from "vuelidate/lib/validators";


export default {
  name: "Personal",
  props: {
    isLoading: Boolean,
    image: String,
    permissions: Object,
    statusList: Array,
    dateFormat: String,
    studentStatus: Array,
    titles: Array,
    student: Object,
    validations: Object,
    countries: Array,
    partners: Array,
    partnercampus: Array,
    partnersDisabled: Boolean,
    selectedPartner: Function,
    readonly: Boolean,
    status: Object,
    statusDate: String,
    
    studentProgram: Object,
    showAlert: Function,
    markGraduated: Function,
    formatDate: Function,
    Withdraw: Function,
    deleteStatus: Function,
    getStudent: Function,
  },

  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      hovering: false,
      imageUrl: this.image,
      ExportAddressMethod: "pdf",
      StatusDate: this.toDayDate(),
      request_source: '',
      isInvalidDate:'',
      isInvalidDate2:'',
      statusCreateMode: false,
      options: [],
      linkedStudents: [],
      studentName: '',
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
      },
    };
  },
  watch:{
    "student.PassportExpiry": function (val) {
      if(val ==null){this.clearDatepicker();}
      this.onChangePassportExpiryDate();
    },

    "student.PermitExpiry": function (val)  {
      if(val ==null){this.clearDatepicker2();}
      this.onChangePermitExpiryDate();
    },

    image(newValue) {
      this.imageUrl = newValue;
    },

    student: {
      handler(newStudent) {
        if (newStudent && newStudent.ID) {
          this.fetchLinkedStudents();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
   
    changeStatus: {
      get: function () {
        return this.status;
      },
      set: function (newStatus) {
        this.$emit("update:status", newStatus);
      },
    },
  },

  methods: {

    async fetchLinkedStudents() {
      await axios.get(`/api/students/${this.student.ID}/links`).then(res => {
        this.linkedStudents = res.data;
      });
    },
    async addLink(student) {
      await axios.post(`/api/students/${this.student.ID}/links`, {
        linked_student_id: student.ID,
      }).then(() => {
        this.selected = null;
        this.clear();
        this.fetchLinkedStudents();
      });
    },
    async removeLink(linkedId) {
      await axios.post(`/api/students/${this.student.ID}/links/remove`, {
        linked_student_id: linkedId,
      }).then(() => {
        this.fetchLinkedStudents();
      });
    },

    /**
     * Search students
     */
    async searchStudent() {
      if (this.studentName == '') {
        this.clear();
        return;
      }

      let source = axios.CancelToken.source();

      if (this.request_source != '')
          this.request_source.cancel('Operation canceled by the user.');

      this.request_source = source;

      axios
          .get(`/api/students?nameOrNumber=${this.studentName}`)
          .then(resp => this.options = resp.data.data.data)
          .catch(error => {console.log(error)});
    },

    clear() {
        this.options = [];
        this.studentName = '';
    },

    /**
     * Go to student edit page or alumni edit page
     */
    async editStudent(studentNumber) {
      if (!this.permissions.viewStudents) return;
      let res = await axios.get(`/api/students/${studentNumber}/find`);
      if (res.data.exists) {
          this.$router.push({
          name: "StudentEdit",
          params: {
            id: studentNumber,
          },
        });
      } else {
        this.$router.push({
          name: "AlumniEdit",
          params: {
            id: studentNumber,
          },
        });
      }
    },

    showSelectedImage(event) {
      const file = event.target.files[0];
      if (file) {
        this.image = URL.createObjectURL(file);
      }
    },
    replaceImage() {
      if (this.image) {
        const confirmed = confirm("Do you really want to replace the existing picture?");
        if (confirmed) {
          this.$refs.profile_image.click();
        }
      }
    },
    confirmDelete() {
      const confirmed = confirm("Do you really want to remove the existing picture?");
      
      if (confirmed) {
          const attach = { student_number: this.student.StudentNumber };
          axios
          .post("/api/deleteProfileImage", attach)
          .then(response => {
              if (response.data.error) {
                  this.showAlert(response.data.message, "warning");
              } else if (response.data.success) {
                this.getStudent();
                this.imageUrl = "/images/student.jpg";
                this.showAlert(response.data.message, "success");
              }
          })
          .catch(error => {
              if (error.response && error.response.status === 403) {
                  this.showAlert(error.response.data.message, "warning");
              } else {
                  console.log("error", error);
              }
          });
      }
    },

    /**
     * Delete student status entry
     */
    deleteStatusEntry(index) {
      let conf = confirm(this.$t("form.validation.deleteStatus"));

      if (conf === true) {
        this.$emit("update:isLoading", true);

        axios
          .delete(
            `/api/students/${this.student.ID}/studentstatus/${this.student?.status[index]?.pivot?.ID}`
          )
          .then((response) => {
            this.$emit("deleteStatus", index);
            this.showAlert(response.data.message);
            this.$emit("update:isLoading", false);
          })
          .catch((error) => {
            this.showAlert(error.response.data.message, "danger");
            this.$emit("update:isLoading", false);
          });
      }
    },
    clearDatepicker(){
      return this.isInvalidDate= "";
    }, clearDatepicker2(){
      return this.isInvalidDate2= "";
    },
    onChangeStatus() {
      this.statusCreateMode = true;
      
      // Check if the selected status is "Graduated"
      if (this.status && (this.status.StatusName === 'Graduated' || this.status.StatusID == 3)) {
          
          // If GraduationDate exists in the program tab, use it. Otherwise, use today.
          if (this.studentProgram && this.studentProgram.GraduationDate) {
              this.StatusDate = this.studentProgram.GraduationDate;
          } else {
              this.StatusDate = this.toDayDate();
          }          
      } else {
        // For all other statuses, default to today
        this.StatusDate = this.toDayDate();
      }
    },
    async addStatus() {
      if (!this.status.StatusID) {
        this.showAlert(this.$t("form.validation.invalidStatus"), "danger");
        return;
      }

      let graduated = false;

      if (this.status.StatusName === "Graduated") {
        graduated = confirm(this.$t("form.validation.graduateCheck"));
        if (!graduated) {
          return;
        }
        this.StatusDate = this.studentProgram.GraduationDate ? this.studentProgram.GraduationDate : this.toDayDate();
      }

      // Now safe to make changes
      this.statusCreateMode = false;
      this.student.CurrentStatus = this.status.StatusID;

      if (this.status.StatusID == 4) {
        this.$emit("Withdraw", -1);
      } else {
        this.$emit("Withdraw", 0);
      }

      let data = {
        status: {
          StudentStatusID: this.status.StatusID,
          StudentStatusName: this.status.StatusName,
          StudentStatusComment: this.status.StatusComment,
          StudentStatusDate: this.StatusDate,
        },
        student: {},
        graduate: 0,
      };

      const newD = moment(this.StatusDate, this.dateFormat).toDate();

      if (this.status.StatusName === "Graduated") {
        data.graduate = true;
      }

      this.studentStatus.unshift({
        StudentStatusID: this.status.StatusID,
        StudentStatusName: this.status.StatusName,
        StudentStatusComment: this.status.StatusComment,
        StudentStatusDate: newD,
      });

      data.student.CurrentStatus = this.student.CurrentStatus;

      if (this.studentProgram.Graduate) {
        data.graduate = 1;
        data.program = JSON.stringify(this.studentProgram);
        data.graduateReq = JSON.stringify(this.studentGraduateReq);
      }

      axios
        .post(`/api/students/${this.student.ID}/status`, data)
        .then((response) => {
          this.isLoading = false;
          this.showAlert(response.data.message);
          this.statusCreateMode = false;

          if (response.data.data.graduate == 1) {
            setTimeout(() => {
              this.$router.push({
                name: "AlumniEdit",
                params: [{ id: this.student.ID }],
              });
            }, 2000);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
        });
    },
    onChangeStatusDate() {
      this.$emit("update:statusDate", this.StatusDate);
    },
    onChangePassportExpiryDate(){
      if(this.student.PassportExpiry==null){return false;}
      let value = this.student.PassportExpiry;
      if (!value) {
          // Value is not set, so return true to pass the validation
          return true
        }
      
      // Convert input date string to moment object and format to "YYYY-MM-DD" format
      const inputDate = moment(value, "DD.MM.YYYY").format("YYYY-MM-DD");

      // Get current date as moment object
      const currentDate = moment();

      // Calculate the difference in months between the two dates
      const diffInMonths = moment(inputDate).diff(currentDate, "months");


      if(diffInMonths<=1  ){
        
        return this.isInvalidDate= "is-invalid";

      }
      return this.isInvalidDate= "";

    },  
   
    onChangePermitExpiryDate(){
      if(this.student.PermitExpiry==null){return false;}
      let value = this.student.PermitExpiry;
      if (!value) {
          // Value is not set, so return true to pass the validation
          return true
        }
      
      // Convert input date string to moment object and format to "YYYY-MM-DD" format
      const inputDate = moment(value, "DD.MM.YYYY").format("YYYY-MM-DD");

      // Get current date as moment object
      const currentDate = moment();

      // Calculate the difference in months between the two dates
      const diffInMonths = moment(inputDate).diff(currentDate, "months");


  if(diffInMonths<=1  ){
    
    return this.isInvalidDate2= "is-invalid";
  

  }
  return this.isInvalidDate2= "";

    },

    showSelectedImage() {
      let input = this.$refs.profile_image;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.$emit("update:image", e.target.result);
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }

      let fd = new FormData();
      fd.append("file", file[0]);
      fd.append("StudentNumber", this.$route.params.id);

      this.$emit("update:isLoading", true);

      axios
        .post("/api/students/profile-image", fd)
        .then((resp) => {
          this.student.Photo =
            resp.data.student_number + "/" + resp.data.filename;
          this.$emit("update:isLoading", false);
        })
        .catch((error) => {
          this.$emit("update:isLoading", false);
          console.log("file not found");
        });
    },
    async createToken(type) {
      let response = await axios.post("/api/api-tokens", {
        type,
      });
      let token = "";

      if (response.status == 200) {
        token = response.data.extra[0].token;
      }

      return token;
    },

    /**
     * Export students list - PDF | Word | Text
     */
    async generate(method) {
      let token = await this.createToken("students-export");
      if (token == "") return;
      window.open(
        `/students/address/export?method=${method}&token=${token}&student=${this.$route.params.id}&mailaddress=${this.student.MailAddress}`,
        "_blank"
      );
    },

    toDayDate() {
      
      return moment().format(this.dateFormat);
    },
  },
  validations: {
    student: {
      FirstName: {
        required,
        maxLength: maxLength(100),
      },
      LastName: {
        required,
        maxLength: maxLength(100),
      },
      BirthPlace: {
       
        maxLength: maxLength(100),
      },
      Email: {
        required,
        email,
      },
      MatriculationNum: {
        maxLength: maxLength(50),
        // regular expression to allow dashes
           pattern: value => /^[-\w]+$/i.test(value),
      },
      PassportExpiry: {
    
     
    },
    }
  },
};
</script>
<style>
.date-picker.is-invalid {
  border-color: #dc3545;
  border-style: double;
}
.icon-overlay {
  bottom: 10px;
  pointer-events: none;
}

button {
  pointer-events: all;
}
</style>